import {
  QLIK_LOADING,
  GET_QLIK_APPS,
  GET_QLIK_APP,
  GET_QLIK_SHEETS,
  GET_QLIK_OBJECTS,
  GET_QLIK_OBJECT,
  GET_QLIK_CONNECTION,
  SET_QLIK_OPTIONS,
  RESET_QLIK_STATE,
  GET_QLIK_STREAMS,
  GET_QLIK_SAAS_SPACES,
  GET_QLIK_ERRORS,
  CLEAR_QLIK_OPTIONS,
} from '../actions/types'

const initialState = {
  loading: false,
  sheets: null,
  spaces:null,
  apps: null,
  object: null,
  objects: null,
  connection: null,
  options: null,
  errors: null,
}
export default function (state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case QLIK_LOADING:
      return {
        ...state,
        loading: true,
        errors: null,
      }
    case GET_QLIK_CONNECTION:
      return {
        ...state,
        loading: false,
        connection: payload,
        errors: null,
      }
    case GET_QLIK_APPS:
      return {
        ...state,
        loading: false,
        apps: payload,
      }
    case GET_QLIK_APP:
      return {
        ...state,
        loading: false,
        app: payload,
      }
    case GET_QLIK_SHEETS:
      return {
        ...state,
        loading: false,
        sheets: payload,
      }
    case GET_QLIK_OBJECTS:
      return {
        ...state,
        loading: false,
        objects: payload,
      }
    case GET_QLIK_OBJECT:
      return {
        ...state,
        loading: false,
        object: payload,
      }
    case GET_QLIK_STREAMS:
      return {
        ...state,
        loading: false,
        streams: payload,
      }
    case GET_QLIK_SAAS_SPACES:
      return {
        ...state,
        loading: false,
        spaces: payload,
      }
    case SET_QLIK_OPTIONS:
      return {
        ...state,
        options: payload,
        loading: false,
      }
    case CLEAR_QLIK_OPTIONS:
      return {
        ...state,
        options: null,
        loading: false,
      }
    case GET_QLIK_ERRORS:
      return {
        ...state,
        loading: false,
        sheets: null,
        apps: null,
        object: null,
        objects: null,
        connection: null,
        errors: payload,
      }

    case RESET_QLIK_STATE:
      return {
        loading: false,
        sheets: null,
        apps: null,
        object: null,
        objects: null,
        connection: null,
        error: null,
        options: null,
      }
    default:
      return state
  }
}
